
export interface Dashboard {
    columns?: Widget[][];
    id?: string;
    layout?: DashboardLayoutKind;
    title?: string;
    urlPart?: string;
}

export interface Widget {
    component?: any;
    configuration?: any;
    title?: string;
}

export enum DashboardLayoutKind {
    TwoColumnLeftLarge = 1,
    TwoColumnRightLarge,
    TwoColumnEqual,
    ThreeColumn,
    SingleColumn
}

export enum WidgetKind {
    Chart = "Chart",
    Grid = "Grid",
    Map = "Map",
    WorkOrder = "WorkOrder",
    FullCalendar = "FullCalendar",
    ListCalendar = "ListCalendar",
    RegistrationRequest = "RegistrationRequest",
    Permits = "Permits",
    FinancialAssurance = "FinancialAssurance",
    ExternalPermit = "ExternalPermit",
    ExternalWorkOrder = 'ExternalWorkOrder',
    PendingMail = "PendingMail",
    Scanning = "Scanning",
    FinancialAssuranceInternal = "FinancialAssuranceInternal",
    PendingPayments = "PendingPayments",
    OrgFiles = "OrgFiles",
    Wells = "Wells",
    ExternalChiefsOrdersStatus = "ExternalChiefsOrdersStatus",
    PendingWellTransfer = "PendingWellTransfer",
    WellTransferSeller = "WellTransferSeller",
  
    ExternalUpcomingBondExpiration = "ExternalUpcomingBondExpiration",
    InternalUpcomingBondExpiration = "InternalUpcomingBondExpiration",

    InternalUpcomingInsuranceExpiration = "InternalUpcomingInsuranceExpiration",

    WellSellerTransfer = "WellSellerTransfer",
    InternalInspections = "InternalInspections",
    WellBuyerTransfer = "WellBuyerTransfer",
    ExternalPayments = "ExternalPayments",
    Notifications = "Notifications",
    Utility = "Utility",
    External7ATransfer = "External7ATransfer",
    Issues = "Issues",
    DataCorrections = "DataCorrections",
    ExternalDataCorrectionRequests = "ExternalDataCorrectionRequests",
    InternalDataCorrectionRequests = "InternalDataCorrectionRequests",
    PaperSubmissions = "PaperSubmissions",
    
    ExternalOrganizationManagement = "ExternalOrganizationManagement",
    InternalOrganizationManagement = "InternalOrganizationManagement",
    InternalComplianceReport = "InternalComplianceReport",
    ExternalComplianceReport = "ExternalComplianceReport",
    ExternalIssues = "ExternalIssues",
    WellSearch = "WellSearch",
    LandownerPassthrough = "LandownerPassthrough"
}